var _a;
export class SpriteConst {
}
_a = SpriteConst;
SpriteConst.TEXT = 0x01;
SpriteConst.AREA2D = 0x02;
SpriteConst.CANVAS = 0x08;
SpriteConst.POSTPROCESS = 0x10;
SpriteConst.MASK = 0x20;
SpriteConst.CLIP = 0x40;
SpriteConst.GRAPHICS = 0x100;
SpriteConst.RENDERNODE2D = 0x800;
SpriteConst.DRAW2RT = _a.CANVAS | _a.POSTPROCESS | _a.MASK;
SpriteConst.UPDATETRANS = _a.CANVAS | _a.POSTPROCESS | _a.MASK | _a.CLIP | _a.GRAPHICS | _a.RENDERNODE2D;
export var RepaintFlag;
(function (RepaintFlag) {
    RepaintFlag[RepaintFlag["Normal"] = 0] = "Normal";
    RepaintFlag[RepaintFlag["Size"] = 1] = "Size";
    RepaintFlag[RepaintFlag["Graphics"] = 2] = "Graphics";
    RepaintFlag[RepaintFlag["ChildChange"] = 4] = "ChildChange";
    RepaintFlag[RepaintFlag["UpdateRT"] = 7] = "UpdateRT";
})(RepaintFlag || (RepaintFlag = {}));
export var TransformKind;
(function (TransformKind) {
    TransformKind[TransformKind["Pos"] = 1] = "Pos";
    TransformKind[TransformKind["Width"] = 2] = "Width";
    TransformKind[TransformKind["Height"] = 4] = "Height";
    TransformKind[TransformKind["Anchor"] = 8] = "Anchor";
    TransformKind[TransformKind["Scale"] = 16] = "Scale";
    TransformKind[TransformKind["Skew"] = 32] = "Skew";
    TransformKind[TransformKind["Rotation"] = 64] = "Rotation";
    TransformKind[TransformKind["Matrix"] = 128] = "Matrix";
    TransformKind[TransformKind["Size"] = 6] = "Size";
    TransformKind[TransformKind["Layout"] = 30] = "Layout";
    TransformKind[TransformKind["TRS"] = 113] = "TRS";
})(TransformKind || (TransformKind = {}));
export var BaseRender2DType;
(function (BaseRender2DType) {
    BaseRender2DType[BaseRender2DType["empty"] = -1] = "empty";
    BaseRender2DType[BaseRender2DType["baseRenderNode"] = 0] = "baseRenderNode";
    BaseRender2DType[BaseRender2DType["spine"] = 1] = "spine";
    BaseRender2DType[BaseRender2DType["particle"] = 2] = "particle";
    BaseRender2DType[BaseRender2DType["spineSimple"] = 3] = "spineSimple";
    BaseRender2DType[BaseRender2DType["graphics"] = 4] = "graphics";
})(BaseRender2DType || (BaseRender2DType = {}));
export var SubPassFlag;
(function (SubPassFlag) {
    SubPassFlag[SubPassFlag["PostProcess"] = 1] = "PostProcess";
    SubPassFlag[SubPassFlag["CacheAsBitmap"] = 2] = "CacheAsBitmap";
    SubPassFlag[SubPassFlag["Mask"] = 4] = "Mask";
    SubPassFlag[SubPassFlag["RenderTexture"] = 8] = "RenderTexture";
    SubPassFlag[SubPassFlag["UPDATE_POSTPROCESS"] = 9] = "UPDATE_POSTPROCESS";
})(SubPassFlag || (SubPassFlag = {}));
